export {
    getStatusMetadata,
    getRequestStatusMetadata,
    getReceiptPendingLabel,
    MODALITY_LABELS,
    SELL_STATUS_LABELS,
} from '../../vacations.definitions';
export type { StatusMetadata } from '../../vacations.definitions';

export const VIEW_DETAILS_LABEL = 'Ver detalhes';

export function getViewDetailsAriaLabel(modalityLabel: string): string {
    return `Ver detalhes da solicitação de ${modalityLabel}`;
}

export function buildDraftCountdownLabel(remainingLabel: string): string {
    return `Você pode excluir esta solicitação por mais ${remainingLabel}.`;
}
